import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import NotificationDialog from './notifications/NotificationDialog';

CheckPermissions.propTypes = {
  hasCheckedPermissions: PropTypes.bool,
  setHasCheckedPermissions: PropTypes.func,
};

export default function CheckPermissions(props) {
  const { hasCheckedPermissions, setHasCheckedPermissions } = props;
  const [permissionsInfo, setPermissionsInfo] = useState({
    open: false,
    msg: '',
    title: 'Permissions',
  });

  const checkPermissions = async () => {
    // Currently only compatible with Chrome/Edge/Firefox not IE or Safari
    try {
      const [checkMic, checkVideo] = await Promise.all([
        navigator.permissions
          .query({ name: 'microphone' })
          .catch((e) => console.log('Permissions Query Error On Microphone', e)),
        navigator.permissions
          .query({ name: 'camera' })
          .catch((e) => console.log('Permissions Query Error On Camera', e)),
      ]);

      const micGranted = checkMic?.state === 'granted';
      const videoGranted = checkVideo?.state === 'granted';
      if (!micGranted || !videoGranted) {
        const bothDenied = !micGranted && !videoGranted;
        const msg = `In order to use this application, please grant your browser permissions for your ${
          !micGranted ? 'microphone ' : ''
        }${bothDenied ? 'and ' : ''}${
          !videoGranted ? 'camera ' : ''
        }which can usually be set by clicking icon to the left of the url.`;
        setPermissionsInfo((currentPermissionsInfo) => ({
          ...currentPermissionsInfo,
          open: true,
          msg,
        }));
      }
    } catch (e) {
      console.log('Check Permissions Error::', e);
    }
    setHasCheckedPermissions(true);
  };

  useEffect(() => {
    if (hasCheckedPermissions === false) {
      checkPermissions();
    }
    // eslint-disable-next-line
  }, [hasCheckedPermissions]);

  return <NotificationDialog state={permissionsInfo} setState={setPermissionsInfo} />;
}
